import React from "react";
import LineAreaChartToolTip from './LineAreaChartToolTip';
import BarChartToolTip from './BarChartToolTip';
import DualAxisLineChartToolTip from './DualAxisLineChartToolTip';

export default class ToolTipPopover extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="tool-tip-wrapper">
        {this.props.report_details.chart_type.name === 'line_chart' || this.props.report_details.chart_type.name === 'area_chart' ? <LineAreaChartToolTip {...this.props} /> : null}
        {this.props.report_details.chart_type.name === 'vertical_bar_chart' ? <BarChartToolTip {...this.props} /> : null}
        {this.props.report_details.chart_type.name === 'dual_axis_line_chart' ? <DualAxisLineChartToolTip {...this.props} /> : null}
      </div>
    );
  };

};
